(function () {
  "use strict";

  let currentMode = null;

  function destroyAllSwipers() {
    const mainSwiperEl = document.querySelector(".product-main-swiper");
    const thumbSwiperEl = document.querySelector(".product-thumb-swiper");
    const mobileSwiperEl = document.querySelector(".product-mobile-swiper");

    if (mainSwiperEl && mainSwiperEl.swiper) {
      mainSwiperEl.swiper.destroy(true, true);
    }
    if (thumbSwiperEl && thumbSwiperEl.swiper) {
      thumbSwiperEl.swiper.destroy(true, true);
    }
    if (mobileSwiperEl && mobileSwiperEl.swiper) {
      mobileSwiperEl.swiper.destroy(true, true);
    }
  }

  function initProductGallerySwiper() {
    if (typeof Swiper === "undefined") return;

    const isDesktop = window.innerWidth > 990;
    const mode = isDesktop ? "desktop" : "mobile";

    if (currentMode === mode) return;

    destroyAllSwipers();
    currentMode = mode;

    if (isDesktop) {
      const mainSwiperEl = document.querySelector(".product-main-swiper");
      const thumbSwiperEl = document.querySelector(".product-thumb-swiper");

      if (!mainSwiperEl || !thumbSwiperEl) return;

      setTimeout(function () {
        const thumbSwiper = new Swiper(".product-thumb-swiper", {
          spaceBetween: 10,
          slidesPerView: 6,
          slidesPerGroup: 1,
          freeMode: false,
          watchSlidesProgress: true,
          slideToClickedSlide: true,
          grabCursor: true,
          allowTouchMove: true,
          resistance: true,
          resistanceRatio: 0.85,
          breakpoints: {
            320: { slidesPerView: 4 },
            640: { slidesPerView: 5 },
            768: { slidesPerView: 6 },
          },
        });

        const mainSwiper = new Swiper(".product-main-swiper", {
          spaceBetween: 0,
          effect: "slide",
          speed: 400,
          loop: true,
          thumbs: { swiper: thumbSwiper },
          navigation: {
            nextEl: ".product-main-next",
            prevEl: ".product-main-prev",
          },
          keyboard: {
            enabled: true,
            onlyInViewport: true,
          },
          on: {
            slideChange: function () {
              if (thumbSwiper) {
                const realIndex = this.realIndex;
                const totalSlides = thumbSwiper.slides.length;
                const slidesPerView = 6;

                if (totalSlides <= slidesPerView) {
                  return;
                }

                let targetSlide = 0;
                if (realIndex < 3) {
                  targetSlide = 0;
                } else if (realIndex >= totalSlides - 3) {
                  targetSlide = totalSlides - slidesPerView;
                } else {
                  targetSlide = realIndex - 2;
                }

                thumbSwiper.slideTo(targetSlide, 400);
              }
            },
          },
        });
      }, 100);
    } else {
      const mobileSwiperEl = document.querySelector(".product-mobile-swiper");
      const progressBar = document.querySelector(".swiper-progress-bar");

      if (!mobileSwiperEl) return;

      setTimeout(function () {
        const mobileSwiper = new Swiper(".product-mobile-swiper", {
          slidesPerView: 1,
          spaceBetween: 0,
          effect: "slide",
          speed: 400,
          grabCursor: true,
          on: {
            init: function () {
              updateProgressBar(this);
            },
            slideChange: function () {
              updateProgressBar(this);
            },
          },
        });

        function updateProgressBar(swiper) {
          if (progressBar && swiper.slides.length > 0) {
            const totalSlides = swiper.slides.length;
            const segmentWidth = 100 / totalSlides;
            const translatePercent = swiper.activeIndex * 100;

            progressBar.style.width = segmentWidth + "%";
            progressBar.style.transform = "translateX(" + translatePercent + "%)";
          }
        }
      }, 100);
    }
  }

  function waitForSwiper(callback, maxAttempts = 50) {
    let attempts = 0;
    function checkSwiper() {
      attempts++;
      if (typeof Swiper !== "undefined") {
        callback();
      } else if (attempts < maxAttempts) {
        setTimeout(checkSwiper, 100);
      }
    }
    checkSwiper();
  }

  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      initProductGallerySwiper();
    }, 250);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      waitForSwiper(initProductGallerySwiper);
    });
  } else {
    waitForSwiper(initProductGallerySwiper);
  }
})();
